// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1MUD8","colCheckbox":"styles_colCheckbox__3FKBM"};